
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _91slug_93klqvwrwgFngOjIlRZdOv6Y2i_xtuPW6CDzziWpX_bicMeta } from "/vercel/path0/pages/[slug].vue?macro=true";
import { default as indexG_WfXOzFIdmY7nC2wskK9_5LGE8hGwIJyZEyCaXLOuMMeta } from "/vercel/path0/pages/index.vue?macro=true";
import { default as loginyiubrZraL9EDD3J38Z_45ftLpCUym9OoYm1Hb9453rWnMMeta } from "/vercel/path0/pages/login.vue?macro=true";
import { default as erfassenFOE_45h5nEWWFbqFdayb7jnApCX6b7vu_qx_yyLF8BPM4Meta } from "/vercel/path0/pages/lp/[[class]]/coaching/[student]/erfassen.vue?macro=true";
import { default as indexK7Af7Ihf2ZudLI01EwW3Te3v8oTIQ2iS2dkx6P1MwOEMeta } from "/vercel/path0/pages/lp/[[class]]/coaching/[student]/index.vue?macro=true";
import { default as index3K4hYYovnQ7K_fTZJJyPcdicvoAt79jlQw4SKITjmJYMeta } from "/vercel/path0/pages/lp/[[class]]/coaching/index.vue?macro=true";
import { default as coachingtJwLLt7nx8MbKPPgft0X4dGrBVq6edHB2mYQdkIHWJkMeta } from "/vercel/path0/pages/lp/[[class]]/coaching.vue?macro=true";
import { default as indexa7APOOgnCXy5rJMtwapUN5TghcgWkFpiURvFobWfAmgMeta } from "/vercel/path0/pages/lp/[[class]]/index.vue?macro=true";
import { default as _91assessment_93_p3PMbyDqCrb5t0Ej1ohWiEt68XvGNfyWvjrPtXwNe8Meta } from "/vercel/path0/pages/lp/[[class]]/lernwege/[path]/[student]/[assessment].vue?macro=true";
import { default as _91_91id_93_936i1XBhPfs0Lz_457Caw13QNwUcEPPWX4ZywYFUt32eJ_45IMeta } from "/vercel/path0/pages/lp/[[class]]/lernwege/[path]/[student]/erfassen/[[id]].vue?macro=true";
import { default as indexnhwNjS07Vg3ZnHLi1NrC4qF2le5VS03J3vTUzLj_I60Meta } from "/vercel/path0/pages/lp/[[class]]/lernwege/[path]/index.vue?macro=true";
import { default as indexQdRStBcta0wixIZ3HQxwgLsq1BwTuFmRMKHSHJrwo2MMeta } from "/vercel/path0/pages/lp/[[class]]/lernwege/index.vue?macro=true";
import { default as lernwege_aiB7j89kilrKfXjlQLI4zg_45Nq41PSIu6NvXaWwTXioMeta } from "/vercel/path0/pages/lp/[[class]]/lernwege.vue?macro=true";
import { default as index_ioz0xm1KnOqFTcW4A2Y7LAYusoXgFdZj2adWx6zkigMeta } from "/vercel/path0/pages/lp/[[class]]/schueler:in/[student]/[path]/index.vue?macro=true";
import { default as indexMZg84eAqQDSF5DqqRAQFs1kagQ_hHGBl144OZp7zjpEMeta } from "/vercel/path0/pages/lp/[[class]]/schueler:in/[student]/index.vue?macro=true";
import { default as indexkZv_45heridLRfTbOtWc5JEvAjqC99_MYhco7WqAZDtqEMeta } from "/vercel/path0/pages/lp/[[class]]/schueler:in/index.vue?macro=true";
import { default as schueler_58inuCKqgnGMCSos2t4DBM0NiZ2SOUcxuX92i30aMxZntbUMeta } from "/vercel/path0/pages/lp/[[class]]/schueler:in.vue?macro=true";
import { default as _91slug_93QZKX1ZNwX4bzVSmDtK40GOhq2LRUivqshX_45q58n8_45O8Meta } from "/vercel/path0/pages/lp/material/[slug].vue?macro=true";
import { default as index9AYhj_NpoYaRKQP_45vPJUbbesMPFuql7MpBQ5S2biU4AMeta } from "/vercel/path0/pages/lp/material/index.vue?macro=true";
import { default as materialqCvl56aS12dxARhxczdLJ0_45TqFKFP_fyhxU5J5UMbEUMeta } from "/vercel/path0/pages/lp/material.vue?macro=true";
import { default as lpPJ9fFbdQMnQI_9U8x7PpdVcCTzrBKZyv8zoSZcYzZlIMeta } from "/vercel/path0/pages/lp.vue?macro=true";
import { default as index6jWEbwZxK0_gxbq2YkDVINdyZQtuHVSmuPTkpoYS_455UMeta } from "/vercel/path0/pages/sus/index.vue?macro=true";
import { default as _91assessment_93Fiz_45_45G12po0BAj6x_2A8UC9e9SDyxSXsRQD09m3gtZwMeta } from "/vercel/path0/pages/sus/lernwege/[path]/[assessment].vue?macro=true";
import { default as _91_91continueId_93_93SQH0_45ujVqtb6V2ntudmuLWeormd5ikrFoWfhrVOsBEUMeta } from "/vercel/path0/pages/sus/lernwege/[path]/neu/[[continueId]].vue?macro=true";
import { default as _91path_93quPPVE0uT4RqH6o0dMWLTy9s_45RL20rSMNRTDN3pMiRYMeta } from "/vercel/path0/pages/sus/lernwege/[path].vue?macro=true";
import { default as indexO_45kfN28P4UEIbzeW9MwPxcg1c3pEYVempBBJMJerdDAMeta } from "/vercel/path0/pages/sus/lernwege/index.vue?macro=true";
import { default as lernwegeUvItdjkxK5TtTTPuP_RzRfiqZOISJ_ECTOMe_9aqoaAMeta } from "/vercel/path0/pages/sus/lernwege.vue?macro=true";
import { default as ruckmeldungen_45Shc9KnsjwNkRPHVV_vF3bylxxxamyYaVMyRU5umiMQMeta } from "/vercel/path0/pages/sus/ruckmeldungen.vue?macro=true";
import { default as suseHNUXaz8ANM5_WsRyfh1unFoWxUbsmCfzDMnHT9gGvcMeta } from "/vercel/path0/pages/sus.vue?macro=true";
import { default as themeINfvFhMtbHIGZUa2clFAyK7c6HWRr6hEeOkD6hQFkMoMeta } from "/vercel/path0/pages/theme.vue?macro=true";
import { default as _91user_93myPSIGOpnmL0LhDR4yTEV_kK5_Qij012lXcuwR0eOFgMeta } from "/vercel/path0/pages/verwalten/benutzerverwaltung/[user].vue?macro=true";
import { default as indexatdLMNR_nD_sgf3dq8dwBgnuKzPXZNElP5tbWjcYeysMeta } from "/vercel/path0/pages/verwalten/benutzerverwaltung/index.vue?macro=true";
import { default as benutzerverwaltunghdADLbMtnbbAZh49coqdY3DH0T5XqD24kcn336uRa7AMeta } from "/vercel/path0/pages/verwalten/benutzerverwaltung.vue?macro=true";
import { default as einstellungenglor_45UE_458DllyCo0pD3iJLpyPSaoPWrRPDZ0_45aXUNWQMeta } from "/vercel/path0/pages/verwalten/einstellungen.vue?macro=true";
import { default as indexJzeFhEGVUUg9VJlTa32RdDjGpAAJfstEnymBEGOT1F0Meta } from "/vercel/path0/pages/verwalten/index.vue?macro=true";
import { default as editIUJPad2P_2sLumZYATQ_45wDnScURCUHPDeW3EMyCFqcMMeta } from "/vercel/path0/pages/verwalten/klassenverwaltung/[class]/edit.vue?macro=true";
import { default as indexpnglLZNfegYhQDb_452SbVNUMPPuYhcOnPsp7kQqKnq_45AMeta } from "/vercel/path0/pages/verwalten/klassenverwaltung/[class]/index.vue?macro=true";
import { default as indexJTOlQm1utA6OaQHO2JuSruxeyKT2ZDa88wlLrF1855UMeta } from "/vercel/path0/pages/verwalten/klassenverwaltung/index.vue?macro=true";
import { default as _91id_93zOotL7HL1FHTy1BXCebZRhYjYD13RBDuK5DPh1GNnHYMeta } from "/vercel/path0/pages/verwalten/klassenverwaltung/sus/[id].vue?macro=true";
import { default as klassenverwaltungE_45GRv2vLaE_omY7nJee7hfsFkTG3FMavDnAxkC4edSsMeta } from "/vercel/path0/pages/verwalten/klassenverwaltung.vue?macro=true";
import { default as verwaltenggS6cNzFUxKQUOy8tw1F8uR20zWqoQR30ypGauyseI4Meta } from "/vercel/path0/pages/verwalten.vue?macro=true";
export default [
  {
    name: "Public",
    path: "/:slug()",
    meta: _91slug_93klqvwrwgFngOjIlRZdOv6Y2i_xtuPW6CDzziWpX_bicMeta || {},
    component: () => import("/vercel/path0/pages/[slug].vue")
  },
  {
    name: "Index",
    path: "/",
    meta: indexG_WfXOzFIdmY7nC2wskK9_5LGE8hGwIJyZEyCaXLOuMMeta || {},
    component: () => import("/vercel/path0/pages/index.vue")
  },
  {
    name: "Login",
    path: "/login",
    meta: loginyiubrZraL9EDD3J38Z_45ftLpCUym9OoYm1Hb9453rWnMMeta || {},
    component: () => import("/vercel/path0/pages/login.vue")
  },
  {
    name: "lp",
    path: "/lp",
    meta: lpPJ9fFbdQMnQI_9U8x7PpdVcCTzrBKZyv8zoSZcYzZlIMeta || {},
    component: () => import("/vercel/path0/pages/lp.vue"),
    children: [
  {
    name: coachingtJwLLt7nx8MbKPPgft0X4dGrBVq6edHB2mYQdkIHWJkMeta?.name,
    path: ":class?/coaching",
    component: () => import("/vercel/path0/pages/lp/[[class]]/coaching.vue"),
    children: [
  {
    name: "CreateCoaching",
    path: ":student()/erfassen",
    meta: erfassenFOE_45h5nEWWFbqFdayb7jnApCX6b7vu_qx_yyLF8BPM4Meta || {},
    component: () => import("/vercel/path0/pages/lp/[[class]]/coaching/[student]/erfassen.vue")
  },
  {
    name: "CoachingStudentOverview",
    path: ":student()",
    meta: indexK7Af7Ihf2ZudLI01EwW3Te3v8oTIQ2iS2dkx6P1MwOEMeta || {},
    component: () => import("/vercel/path0/pages/lp/[[class]]/coaching/[student]/index.vue")
  },
  {
    name: "CoachingOverview",
    path: "",
    meta: index3K4hYYovnQ7K_fTZJJyPcdicvoAt79jlQw4SKITjmJYMeta || {},
    component: () => import("/vercel/path0/pages/lp/[[class]]/coaching/index.vue")
  }
]
  },
  {
    name: "Dashboard",
    path: ":class?",
    meta: indexa7APOOgnCXy5rJMtwapUN5TghcgWkFpiURvFobWfAmgMeta || {},
    component: () => import("/vercel/path0/pages/lp/[[class]]/index.vue")
  },
  {
    name: lernwege_aiB7j89kilrKfXjlQLI4zg_45Nq41PSIu6NvXaWwTXioMeta?.name,
    path: ":class?/lernwege",
    component: () => import("/vercel/path0/pages/lp/[[class]]/lernwege.vue"),
    children: [
  {
    name: "AssessmentDetail",
    path: ":path()/:student()/:assessment()",
    meta: _91assessment_93_p3PMbyDqCrb5t0Ej1ohWiEt68XvGNfyWvjrPtXwNe8Meta || {},
    component: () => import("/vercel/path0/pages/lp/[[class]]/lernwege/[path]/[student]/[assessment].vue")
  },
  {
    name: "CreateAssessment",
    path: ":path()/:student()/erfassen/:id?",
    meta: _91_91id_93_936i1XBhPfs0Lz_457Caw13QNwUcEPPWX4ZywYFUt32eJ_45IMeta || {},
    component: () => import("/vercel/path0/pages/lp/[[class]]/lernwege/[path]/[student]/erfassen/[[id]].vue")
  },
  {
    name: "PathClassOverview",
    path: ":path()",
    meta: indexnhwNjS07Vg3ZnHLi1NrC4qF2le5VS03J3vTUzLj_I60Meta || {},
    component: () => import("/vercel/path0/pages/lp/[[class]]/lernwege/[path]/index.vue")
  },
  {
    name: "Paths",
    path: "",
    meta: indexQdRStBcta0wixIZ3HQxwgLsq1BwTuFmRMKHSHJrwo2MMeta || {},
    component: () => import("/vercel/path0/pages/lp/[[class]]/lernwege/index.vue")
  }
]
  },
  {
    name: schueler_58inuCKqgnGMCSos2t4DBM0NiZ2SOUcxuX92i30aMxZntbUMeta?.name,
    path: ":class?/schueler\\:in",
    component: () => import("/vercel/path0/pages/lp/[[class]]/schueler:in.vue"),
    children: [
  {
    name: "StudentPathOverview",
    path: ":student()/:path()",
    meta: index_ioz0xm1KnOqFTcW4A2Y7LAYusoXgFdZj2adWx6zkigMeta || {},
    component: () => import("/vercel/path0/pages/lp/[[class]]/schueler:in/[student]/[path]/index.vue")
  },
  {
    name: "StudentOverview",
    path: ":student()",
    meta: indexMZg84eAqQDSF5DqqRAQFs1kagQ_hHGBl144OZp7zjpEMeta || {},
    component: () => import("/vercel/path0/pages/lp/[[class]]/schueler:in/[student]/index.vue")
  },
  {
    name: "ClassOverview",
    path: "",
    meta: indexkZv_45heridLRfTbOtWc5JEvAjqC99_MYhco7WqAZDtqEMeta || {},
    component: () => import("/vercel/path0/pages/lp/[[class]]/schueler:in/index.vue")
  }
]
  },
  {
    name: materialqCvl56aS12dxARhxczdLJ0_45TqFKFP_fyhxU5J5UMbEUMeta?.name,
    path: "material",
    component: () => import("/vercel/path0/pages/lp/material.vue"),
    children: [
  {
    name: "Material",
    path: ":slug()",
    meta: _91slug_93QZKX1ZNwX4bzVSmDtK40GOhq2LRUivqshX_45q58n8_45O8Meta || {},
    component: () => import("/vercel/path0/pages/lp/material/[slug].vue")
  },
  {
    name: "MaterialOverview",
    path: "",
    meta: index9AYhj_NpoYaRKQP_45vPJUbbesMPFuql7MpBQ5S2biU4AMeta || {},
    component: () => import("/vercel/path0/pages/lp/material/index.vue")
  }
]
  }
]
  },
  {
    name: suseHNUXaz8ANM5_WsRyfh1unFoWxUbsmCfzDMnHT9gGvcMeta?.name,
    path: "/sus",
    meta: suseHNUXaz8ANM5_WsRyfh1unFoWxUbsmCfzDMnHT9gGvcMeta || {},
    component: () => import("/vercel/path0/pages/sus.vue"),
    children: [
  {
    name: "StudentIndex",
    path: "",
    meta: index6jWEbwZxK0_gxbq2YkDVINdyZQtuHVSmuPTkpoYS_455UMeta || {},
    component: () => import("/vercel/path0/pages/sus/index.vue")
  },
  {
    name: lernwegeUvItdjkxK5TtTTPuP_RzRfiqZOISJ_ECTOMe_9aqoaAMeta?.name,
    path: "lernwege",
    component: () => import("/vercel/path0/pages/sus/lernwege.vue"),
    children: [
  {
    name: "StudentPath",
    path: ":path()",
    meta: _91path_93quPPVE0uT4RqH6o0dMWLTy9s_45RL20rSMNRTDN3pMiRYMeta || {},
    component: () => import("/vercel/path0/pages/sus/lernwege/[path].vue"),
    children: [
  {
    name: "SusAssessment",
    path: ":assessment()",
    meta: _91assessment_93Fiz_45_45G12po0BAj6x_2A8UC9e9SDyxSXsRQD09m3gtZwMeta || {},
    component: () => import("/vercel/path0/pages/sus/lernwege/[path]/[assessment].vue")
  },
  {
    name: "SusNewAssessment",
    path: "neu/:continueId?",
    meta: _91_91continueId_93_93SQH0_45ujVqtb6V2ntudmuLWeormd5ikrFoWfhrVOsBEUMeta || {},
    component: () => import("/vercel/path0/pages/sus/lernwege/[path]/neu/[[continueId]].vue")
  }
]
  },
  {
    name: "StudentPaths",
    path: "",
    meta: indexO_45kfN28P4UEIbzeW9MwPxcg1c3pEYVempBBJMJerdDAMeta || {},
    component: () => import("/vercel/path0/pages/sus/lernwege/index.vue")
  }
]
  },
  {
    name: "StudentFeedback",
    path: "ruckmeldungen",
    meta: ruckmeldungen_45Shc9KnsjwNkRPHVV_vF3bylxxxamyYaVMyRU5umiMQMeta || {},
    component: () => import("/vercel/path0/pages/sus/ruckmeldungen.vue")
  }
]
  },
  {
    name: "theme",
    path: "/theme",
    component: () => import("/vercel/path0/pages/theme.vue")
  },
  {
    name: verwaltenggS6cNzFUxKQUOy8tw1F8uR20zWqoQR30ypGauyseI4Meta?.name,
    path: "/verwalten",
    meta: verwaltenggS6cNzFUxKQUOy8tw1F8uR20zWqoQR30ypGauyseI4Meta || {},
    component: () => import("/vercel/path0/pages/verwalten.vue"),
    children: [
  {
    name: benutzerverwaltunghdADLbMtnbbAZh49coqdY3DH0T5XqD24kcn336uRa7AMeta?.name,
    path: "benutzerverwaltung",
    component: () => import("/vercel/path0/pages/verwalten/benutzerverwaltung.vue"),
    children: [
  {
    name: "UserAdministrationDetail",
    path: ":user()",
    meta: _91user_93myPSIGOpnmL0LhDR4yTEV_kK5_Qij012lXcuwR0eOFgMeta || {},
    component: () => import("/vercel/path0/pages/verwalten/benutzerverwaltung/[user].vue")
  },
  {
    name: "UserAdministration",
    path: "",
    meta: indexatdLMNR_nD_sgf3dq8dwBgnuKzPXZNElP5tbWjcYeysMeta || {},
    component: () => import("/vercel/path0/pages/verwalten/benutzerverwaltung/index.vue")
  }
]
  },
  {
    name: "SettingsAdministration",
    path: "einstellungen",
    meta: einstellungenglor_45UE_458DllyCo0pD3iJLpyPSaoPWrRPDZ0_45aXUNWQMeta || {},
    component: () => import("/vercel/path0/pages/verwalten/einstellungen.vue")
  },
  {
    name: "AdminIndex",
    path: "",
    meta: indexJzeFhEGVUUg9VJlTa32RdDjGpAAJfstEnymBEGOT1F0Meta || {},
    component: () => import("/vercel/path0/pages/verwalten/index.vue")
  },
  {
    name: klassenverwaltungE_45GRv2vLaE_omY7nJee7hfsFkTG3FMavDnAxkC4edSsMeta?.name,
    path: "klassenverwaltung",
    component: () => import("/vercel/path0/pages/verwalten/klassenverwaltung.vue"),
    children: [
  {
    name: "ClassAdministrationEdit",
    path: ":class()/edit",
    meta: editIUJPad2P_2sLumZYATQ_45wDnScURCUHPDeW3EMyCFqcMMeta || {},
    component: () => import("/vercel/path0/pages/verwalten/klassenverwaltung/[class]/edit.vue")
  },
  {
    name: "ClassAdministrationDetail",
    path: ":class()",
    meta: indexpnglLZNfegYhQDb_452SbVNUMPPuYhcOnPsp7kQqKnq_45AMeta || {},
    component: () => import("/vercel/path0/pages/verwalten/klassenverwaltung/[class]/index.vue")
  },
  {
    name: "ClassAdministration",
    path: "",
    meta: indexJTOlQm1utA6OaQHO2JuSruxeyKT2ZDa88wlLrF1855UMeta || {},
    component: () => import("/vercel/path0/pages/verwalten/klassenverwaltung/index.vue")
  },
  {
    name: "UserAdministrationClassDetail",
    path: "sus/:id()",
    meta: _91id_93zOotL7HL1FHTy1BXCebZRhYjYD13RBDuK5DPh1GNnHYMeta || {},
    component: () => import("/vercel/path0/pages/verwalten/klassenverwaltung/sus/[id].vue")
  }
]
  }
]
  }
]